<template>
  <div v-if="isPayemntProcess">
    <!-- 동반가족 추가 결제 -->
    <div class="pf23-family-pay pf23-inFo-L padBSM padTSM widM marTML">
      <p class="fntP">결제방식 선택<span class="ico-must-astar"></span></p>
      <div class="pf12-familyWidth">
        <div class="amway-theme">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="pf23-family-pay-01 amw-radio-wrap radio-label focus 결제방식 선택">
              <input
                type="radio"
                id="payment_type"
                class="amw-global-radio"
                value="DIRECT"
                :name="`payment-radio`"
                :checked="paymentType === 'DIRECT'"
                @change="inputPaymentType('DIRECT');"                
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">계좌이체</span>
            </label>
            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="CREDIT"
                :name="`payment-radio`"
                :checked="paymentType === 'CREDIT'"
                @change="inputPaymentType('CREDIT');"                
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">카드</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 10.27 추가 -->
    
    <div v-if="isPaymentGuideCredit || isPaymentGuideDirect " class="pf23-pay-01 pf23-lineBtm widM pf23-family-pay-how"
      :class="{'pf23-pay-01': isPaymentGuideDirect ,
            'pf23-pay-02': isPaymentGuideCredit,
            'pf23-inFo-C': isPaymentGuideCredit, 
            'pf23-inFo-common': isPaymentGuideCredit, }">
      <!-- 결제설명 -->
      <div>
        <p class="fntE marTML" style="color:#0075a4;">
          * 조당 최대 3명까지(ABO 및 비사업배우자 포함)만 무료로 참석 가능하며, 동반가족이 직계 자녀(자녀의 배우자 제외)로만 구성된 경우 4명을 초과 할 수 있습니다.<br><br>
          * 조당 최대 참석인원은 4명이며(ABO 및 비사업배우자 포함), 나이가 가장 어린 4번째 인원부터 동반가족 비용 납부 대상에 해당됩니다.<br><br>
          * 5번째 인원이 추가될 경우, 객실 최대 투숙인원을 초과함으로 동반가족 비용(연령별 상이) 외 객실료(75만원)가 추가 책정됩니다.
        </p>

        <!-- 테이블 -->
        <table class="osResTb08 fntH6 txtC marTSM">
          <caption>
            <strong>리더십 세미나 사포르 동반 가족 비용</strong>
            <p class="hide">리더십 세미나 사포르 동반 가족 비용 예제 표입니다.</p>
          </caption>
          <colgroup>
            <col style="width:33.33%">
            <col style="width:33.33%">
            <col style="width:33.33%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">동반가족 <br class="moOnly">비용</th>
              <th scope="col">유자격 <br class="moOnly">다이아몬드 이상</th>
              <th scope="col">유자격 <br class="moOnly">다이아몬드 미만</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">만24개월 미만</th>
              <td colspan="2">무료</td>
            </tr>
            <tr>
              <th scope="row">만24개월 <br class="moOnly">~ 만11세
              </th>
              <td colspan="2">120만원</td>
            </tr>
            <tr>
              <th scope="row">만 12세 이상</th>
              <td>160만원</td>
              <td>235만원<br>
                <em class="fntE colorRed">(추가 객실료 75만원 필수 포함)</em>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="osResTb08 fntH6 txtC marTSM">
          <caption>
            <strong>리더십 세미나 사포르 동반 가족 비용</strong>
            <p class="hide">리더십 세미나 사포르 동반 가족 비용 예제 표입니다.</p>
          </caption>
          <colgroup>
            <col style="width:33.33%">
            <col style="width:33.33%">
            <col style="width:33.33%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">객실구분</th>
              <th scope="col">유자격 <br class="moOnly">다이아몬드 이상</th>
              <th scope="col">유자격 <br class="moOnly">다이아몬드 미만</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">최대 투숙 가능 인원</th>
              <td class="txtL">성인 4명 + 만 11세 이하 <br>어린이 1명</td>
              <td class="txtL">
                1) 성인 3명 + 만 11세 이하 
                  어린이 1명<br>혹은
                <br>
                2) 성인 2명 + <span class="disIb">만 11세 이하</span> <br>어린이 2명
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 테이블 -->
      </div>

      <!-- 결제방식-계좌이체 선택시 활성화 .pf23-pay-01 -->
      <div v-if="isPaymentGuideDirect"  class="marTL">
        <div class="pf23-inFo-L padTSM pf23-inFo-common">
          <label for="pf23-pay-01-name" class="fntP bold">입금자명<span class="ico-must-astar" ></span></label>
          <div class="pf12-familyWidth txtR">
            <input
              type="text"
              id="payment_remark" 
              name="pf23-pay-01-name" 
              maxlength="20"
              placeholder="예금주"
              size="50"      
              :class="{'check-red' : hasValid}"         
              :value="paymentRemark"
              @input="inputPaymentRemark(paymentType, $event.target)"
              oninput="javascript: this.value = this.value.replace(/[^a-z|A-Z|ㄱ-ㅎ|ㅏ-ㅣ|가-힣]+$/g, '' );"   
            />
          </div>
        </div>
        <p v-if="hasValid" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">입금자명을 입력해주세요.</p>
        <p class="fntE marTS" style="color:#0075a4;">
          * 입금하실(하신) 입금자명과 동일하게 기재해 주세요.<br>
          * 은행 및 계좌번호, 예금주명 확인 후 송금해 주세요.
        </p>

        <!-- 테이블 -->
        <table class="osResTb06 fntH6 txtC marTSM">
          <caption>
            <strong>입금 은행 및 계좌 번호, 예금주 안내</strong>
            <p class="hide">입금 은행 및 계좌 번호, 예금주 안내 구성된 예제 표입니다.</p>
          </caption>
          <colgroup>
            <col style="width:30%">
            <col style="width:auto">
          </colgroup>

          <tbody>
            <tr style="background-color: #D2DEEF;">
              <th scope="row" style="background-color: #D2DEEF;">은행 및 계좌번호</th>
              <td>{{paymentGuide.DIRECT_BANK }}</td>
            </tr>
            <tr style="background-color: #EAEFF7;">
              <th scope="row" style="background-color: #EAEFF7;">예금주</th>
              <td style="background-color: #EAEFF7;">{{ paymentGuide.DIRECT_DEPOSITOR }}</td>
            </tr>
          </tbody>
        </table>
        <!-- //테이블 -->
      </div>
      
      <!-- 결제방식-신용카드 선택시 활성화 .pf23-pay-02 -->
      <div  v-if="isPaymentGuideCredit" class="marTL">
        <p>리더님의 소중한 개인정보 보호를 위해 모든 결제는 ARS 결제로 진행됩니다. 추후 발송되는 결제요청 문자의 발신번호로 전화를 걸어 안내멘트에 따라 ARS 결제를 부탁드립니다. 결제요청 문자는 1월부터 순차적으로 발송될 예정입니다. 
        </p>
        <p class="fntP padBSM bold marTX" style="color: #0075a4;">*결제링크를 수신할 연락처를 적어 주세요.</p>
        <div class="pf23-input-wrap">
          <label for="pf23-pay-Num01" class="fntP">휴대폰 번호<span class="ico-must-astar"></span></label>
          <div class="pf12-familyWidth txtR">
            <!-- check-red 클래스 추가시 보더 red -->
            010 -<input type="text"
                    id="payment_remark" 
                    name="pf23-pay-Num01" 
                    maxlength="8"
                    placeholder="- 없이 입력"
                    size="50"         
                    :class="{'check-red' : hasValid}"   
                    :value="paymentRemark"
                    @input="inputPaymentRemark(paymentType, $event.target)"     
                    oninput="javascript:this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"         
                  />
            <!-- /// check-red 클래스 추가시 보더 red -->
          </div>
        </div>
        <p v-if="hasValid" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫 010 뒤의 숫자 8자리를 입력해주세요.
        </p>
      </div>
    </div>
    <!-- //결제방식-계좌이체 선택시 활성화 .pf23-pay-01 --> 
    <!-- //동반가족 추가 결제 -->
    <!-- //10.27 추가 -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SAPPORO, GET_CODE_PAYMENT_GUIDE, GET_PAYMENT_TYPE, GET_PAYMENT_REMARK } from '@/store/actions/survey'
import { CommonMethodMixin } from '../mixins'

export default {
  name: 'SurveyParticipantPayment',
  mixins: [CommonMethodMixin],
  props: {
    isPayemntProcess: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      hint: state => state.hint,
    }),
    ...mapGetters(SURVEY_SAPPORO, {
      paymentGuide: GET_CODE_PAYMENT_GUIDE,
      paymentType: GET_PAYMENT_TYPE, 
      paymentRemark: GET_PAYMENT_REMARK
    }),
    isPaymentGuideDirect() { 
      return this.isPayemntProcess && this.paymentType === 'DIRECT'
    },
    isPaymentGuideCredit() { 
      return this.isPayemntProcess && this.paymentType === 'CREDIT'
    },
    hasValid() { 
      if (this.paymentType === 'CREDIT') { 
        const REGEX_NUMBER_ONLY = new RegExp('[0-9]{8}','');
        return !REGEX_NUMBER_ONLY.test(this.paymentRemark) && this.hint
      }else { 
        const REGEX_KOR_ENG_NAME = new RegExp('[a-zA-Zㄱ-ㅎ가-힣-]{2}','');
        return !REGEX_KOR_ENG_NAME.test(this.paymentRemark) && this.hint
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyParticipantPayment.vue